import { easings } from 'react-spring'
import _ from 'lodash'
import { __enforceTypescriptConstraint, AllowReadonly, DeepRequired } from '@feedyou/utils'
import { ExtendedStageInfo, StageDefinition } from './useAnimationStageTimelines'

export const getStagesExtendedInfo = (
  stages: AllowReadonly<StageDefinition[]>
): ExtendedStageInfo[] => {
  let previousStageEndTime = 0
  const extendedSchema: ExtendedStageInfo[] = []

  stages.forEach(stageDefinition => {
    const infoForStage = createExtendedStageInfoItem(stageDefinition, previousStageEndTime)
    extendedSchema.push(infoForStage)

    previousStageEndTime = infoForStage.end
  })

  return extendedSchema
}

export const SCHEMA_DEFAULTS = {
  duration: 500,
  easing: easings.linear,
  stageOverflow: { left: 0, right: 0 },
  extrapolate: { left: false, right: false }
} as const

const applyDefaults = (stage: StageDefinition): DeepRequired<StageDefinition> => {
  return _.merge({}, SCHEMA_DEFAULTS, stage) as DeepRequired<StageDefinition>
}

const createExtendedStageInfoItem = (
  stageDefinition: StageDefinition,
  previousItemEnd: number
): ExtendedStageInfo => {
  const stageWithDefaults = applyDefaults(stageDefinition)

  const begin = previousItemEnd
  const end = previousItemEnd + stageWithDefaults.duration

  return { ...stageWithDefaults, begin, end }
}

__enforceTypescriptConstraint<Partial<StageDefinition>>(SCHEMA_DEFAULTS)
